// Editable fields list
const editableFields = [
    'applicationRole',
    'accountStore',
    'eligibilityType',
    'assigneeType',
    'assignee',
    'actionType',
    'comments',
]

// Helper function to check if a field is editable
export const isEditable = (fieldName) => editableFields.includes(fieldName)

// Action type options for dropdown
const actionTypeOptions = [
    { id: 'Add', label: 'Add' },
    { id: 'Remove', label: 'Remove' },
]
const assignmentTypeOptions = [
    { id: 'PreApproved', label: 'PreApproved' },
    { id: 'Eligible', label: 'Eligible' },
    { id: 'Mandatory', label: 'Mandatory' },
    { id: 'Suggested', label: 'Suggested' },
]
// Helper function to get editable config for a field
const getEditableConfig = (fieldName) => {
    if (!isEditable(fieldName)) return undefined

    // Default config for text input
    const config = {
        type: 'text', // 'text' | 'dropdown' | 'toggle' | 'autocomplete'
        placeholder: '',
    }

    // Field-specific configurations can be added here
    switch (fieldName) {
        case 'applicationRole':
            config.placeholder = 'ApplicationRole'
            break
        case 'accountStore':
            config.placeholder = 'AccountStore'
            break
        case 'eligibilityType':
            return {
                type: 'dropdown',
                placeholder: 'Select',
                options: assignmentTypeOptions,
                getOptionLabel: (option) => option?.label || '',
            }
        case 'assigneeType':
            config.placeholder = 'AssigneeType'
            break
        case 'assignee':
            config.placeholder = 'Assignee'
            break
        case 'actionType':
            return {
                type: 'dropdown',
                placeholder: 'Select',
                options: actionTypeOptions,
                getOptionLabel: (option) => option?.label || '',
            }
        case 'comments':
            config.placeholder = 'Comments'
            break
        default:
            break
    }

    return config
}

const attributes = [
    {
        sticky: 'start',
        name: 'landscapeFriendlyName',
        sortable: true,
        sortBy: 'landscapeFriendlyName',
        label: 'Landscape',
        isEditable: isEditable('landscapeFriendlyName'),
        editableConfig: getEditableConfig('landscapeFriendlyName'),
        hideValue: true,
        component: {
            componentName: 'Landscape',
            props: {
                statusIdProp: 'rtA_CSVInboxLandscapeStatusID',
            },
        },
        styles: {
            width: '120px',
            color: '#282828',
            fontSize: '13px',
        },
    },

    {
        name: 'applicationRole',
        sortable: true,
        sortBy: 'applicationRole',
        label: 'ApplicationRole',
        isEditable: isEditable('applicationRole'),
        editableConfig: getEditableConfig('applicationRole'),
        styles: {
            color: '#282828',
            fontSize: '13px',
            maxWidth: '200px',
        },
    },

    {
        name: 'accountStore',
        sortable: true,
        sortBy: 'accountStore',
        label: 'AccountStore',
        isEditable: isEditable('accountStore'),
        editableConfig: getEditableConfig('accountStore'),
        styles: {
            color: '#282828',
            fontSize: '13px',
        },
    },
    {
        name: 'eligibilityType',
        sortable: true,
        sortBy: 'eligibilityType',
        label: 'EligibilityType',
        isEditable: isEditable('eligibilityType'),
        editableConfig: getEditableConfig('eligibilityType'),
        styles: {
            color: '#282828',
            fontSize: '13px',
        },
    },
    {
        name: 'assigneeType',
        sortable: true,
        sortBy: 'assigneeType',
        label: 'AssigneeType',
        isEditable: isEditable('assigneeType'),
        editableConfig: getEditableConfig('assigneeType'),
        styles: {
            color: '#282828',
            fontSize: '13px',
        },
    },
    {
        name: 'assignee',
        sortable: true,
        sortBy: 'assignee',
        label: 'Assignee',
        isEditable: isEditable('assignee'),
        editableConfig: getEditableConfig('assignee'),
        styles: {
            color: '#282828',
            fontSize: '13px',
            maxWidth: '200px',
        },
    },
    {
        name: 'actionType',
        sortable: true,
        sortBy: 'actionType',
        label: 'ActionTypeName',
        isEditable: isEditable('actionType'),
        editableConfig: getEditableConfig('actionType'),
        styles: {
            color: '#282828',
            fontSize: '13px',
        },
    },

    {
        name: 'comments',
        sortable: true,
        sortBy: 'comments',
        label: 'Comments',
        isEditable: isEditable('comments'),
        editableConfig: getEditableConfig('comments'),
        styles: {
            color: '#282828',
            fontSize: '13px',
            maxWidth: '200px',
        },
    },
    {
        name: 'rtA_CSVInboxItemStatusName',
        sortable: true,
        sortBy: 'rtA_CSVInboxItemStatusName',
        label: 'Status',
        isEditable: isEditable('rtA_CSVInboxItemStatusName'),
        editableConfig: getEditableConfig('rtA_CSVInboxItemStatusName'),
        hideValue: true,
        component: {
            componentName: 'InboxStatusIndicator',
            props: {
                // Map defines which statuses show dropdown and their available options
                dropdownOptionsMap: {
                    Invalid: ['Ignored'],
                    Ignored: ['Invalid'],
                },
                // Property name from item to use as tooltip text
                tooltipProp: 'rtA_CSVInboxItemStatusDescription',
                // Configuration for status change API call
                statusChangeConfig: {
                    // Property name from item to use as the record ID
                    itemIdProp: 'rtA_GroupEligibilityID',
                    // Property name for the ID in the API payload
                    itemIdPayloadKey: 'rtA_GroupEligibilityID',
                    // Property name for the status ID in the API payload
                    statusIdPayloadKey: 'rtA_CSVInboxItemStatusID',
                    // Mapping from status name to status ID (matches GROUP_TO_BUSINESS_ROLE_ITEM_STATUS_TYPE)
                    statusIdMap: {
                        'Not Validated': 1,
                        Valid: 2,
                        Invalid: 3,
                        Ignored: 4,
                        Completed: 5,
                        Error: 6,
                        'Publish Queued': 7,
                        Publishing: 8,
                    },
                },
            },
        },
        sticky: 'end',
        styles: { width: '180px' },
    },
    {
        sticky: 'end',
        styles: { width: '80px' },
        hideValue: true,
        button: { name: 'ShowHideButton' },
    },
]

export default attributes
